import * as tslib_1 from "tslib";
import datapoints from '../datapoints';
import isSearchBoxEmpty from '../utils/isSearchBoxEmpty';
import { observer } from 'mobx-react';
import { Callout } from 'office-ui-fabric-react/lib/Callout';
import { FocusZone } from 'office-ui-fabric-react/lib/FocusZone';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { Label } from 'office-ui-fabric-react/lib/Label';
import { Link } from 'office-ui-fabric-react/lib/Link';
import { List } from 'office-ui-fabric-react/lib/List';
import { Toggle } from 'office-ui-fabric-react/lib/Toggle';
import { logUsage } from 'owa-analytics';
import OWADatePicker from 'owa-datepicker';
import { lazyChangeSearchScope } from 'owa-mail-search-actions';
import { compareSearchScope, getKey } from 'owa-search-service';
import strings from 'owa-strings/owa-mail-strings';
import * as React from 'react';
import { lazySetFromDate, lazySetToDate, lazySetIncludeAttachments, lazySetShowFiltersMenu, searchStore, } from 'owa-mail-search-store';
import getSearchScopeDisplayName from 'owa-mail-search/lib/utils/getSearchScopeDisplayName';
var styles = require('./RefinersCallout.scss');
var RefinersCallout = /** @class */ (function (_super) {
    tslib_1.__extends(RefinersCallout, _super);
    function RefinersCallout() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * Renders a folder option to select to change the scope of the search.
         */
        _this.renderFolderOption = function (option) {
            var isSelected = option.key === getKey(searchStore.staticSearchScope);
            return (React.createElement("button", { className: styles.folderOption + " " + (isSelected ? styles.isSelected : styles.isNotSelected), onClick: function () { return _this.onSelectedSearchScopeChanged(option); }, "data-is-focusable": true },
                isSelected && (React.createElement(Icon, { className: styles.selectedFolderCheckMark, iconName: "CheckMark" /* CheckMark */ })),
                React.createElement("span", null, option.text)));
        };
        _this.onClearFiltersClicked = function (evt) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        evt.stopPropagation();
                        // Clear all refiners.
                        return [4 /*yield*/, lazySetFromDate(null)];
                    case 1:
                        // Clear all refiners.
                        _a.sent();
                        return [4 /*yield*/, lazySetToDate(null)];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, lazySetIncludeAttachments(false)];
                    case 3:
                        _a.sent();
                        return [4 /*yield*/, lazyChangeSearchScope(searchStore.initialSearchScope)];
                    case 4:
                        _a.sent();
                        // Execute callback that refiners have changed.
                        this.onRefinersChanged();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.onSelectedSearchScopeChanged = function (option) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var previousFolderId, _a, eventName, customData;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        previousFolderId = searchStore.staticSearchScope;
                        // Change folder scope.
                        return [4 /*yield*/, lazyChangeSearchScope(option.searchScope)];
                    case 1:
                        // Change folder scope.
                        _b.sent();
                        _a = datapoints.RefinerFolderScopeChanged.datapoint, eventName = _a.name, customData = _a.customData;
                        logUsage(eventName, customData(previousFolderId, searchStore.staticSearchScope /* currentFolderId */));
                        // Execute callback that refiners have changed.
                        this.onRefinersChanged();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.onFromDateChanged = function (date) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, lazySetFromDate(date)];
                    case 1:
                        _a.sent();
                        this.onRefinersChanged(2 /* fromDate */);
                        return [2 /*return*/];
                }
            });
        }); };
        _this.onToDateChanged = function (date) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, lazySetToDate(date)];
                    case 1:
                        _a.sent();
                        this.onRefinersChanged(3 /* toDate */);
                        return [2 /*return*/];
                }
            });
        }); };
        _this.onAttachmentsToggleToggled = function (checked) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, lazySetIncludeAttachments(checked)];
                    case 1:
                        _a.sent();
                        this.onRefinersChanged(1 /* includeAttachments */);
                        return [2 /*return*/];
                }
            });
        }); };
        _this.onDismiss = function (evt) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        evt.stopPropagation();
                        if (!(evt.type !== 'focus' || isSearchBoxEmpty())) return [3 /*break*/, 2];
                        return [4 /*yield*/, lazySetShowFiltersMenu.importAndExecute(false)];
                    case 1:
                        _a.sent();
                        this.props.onDismissed();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); };
        /**
         * This gets called when a refiner is updated.
         *
         * - It hides the callout
         * - It notifies the parent that refiners have changed
         * - It logs when a refiner has been changed (sans folder scope or if
         *   all refiners were cleared)
         */
        _this.onRefinersChanged = function (refinerType) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var _a, eventName, customData;
            return tslib_1.__generator(this, function (_b) {
                // If refinerType was passed in, log the click.
                if (refinerType) {
                    _a = datapoints.RefinerClicked.datapoint, eventName = _a.name, customData = _a.customData;
                    logUsage(eventName, customData(isSearchBoxEmpty(), refinerType));
                }
                // Notify parent that refiners have changed.
                this.props.onRefinersChanged();
                return [2 /*return*/];
            });
        }); };
        return _this;
    }
    RefinersCallout.prototype.render = function () {
        var toDate = searchStore.toDate, fromDate = searchStore.fromDate, includeAttachments = searchStore.includeAttachments;
        var today = new Date();
        return (React.createElement("div", { onClick: function (evt) { return evt.stopPropagation(); }, onKeyDown: function (evt) { return evt.stopPropagation(); } },
            React.createElement(Callout, { directionalHint: 6 /* bottomRightEdge */, directionalHintFixed: true, gapSpace: 1, isBeakVisible: false, onDismiss: this.onDismiss, setInitialFocus: true, target: this.props.targetElement },
                React.createElement("div", null,
                    React.createElement(FocusZone, null,
                        React.createElement(List, { className: styles.folderOptions, items: this.folderOptions, onRenderCell: this.renderFolderOption })),
                    React.createElement("div", { className: styles.attachmentsRefinerContainer },
                        React.createElement(Label, { className: styles.attachmentsLabel }, strings.attachmentsLabel),
                        React.createElement(Toggle, { checked: includeAttachments, className: styles.attachmentsToggle, onChanged: this.onAttachmentsToggleToggled })),
                    React.createElement("div", { className: styles.dateRefinersContainer },
                        React.createElement("div", { className: styles.dateRefinerContainer },
                            React.createElement(OWADatePicker, { className: styles.datePicker, disableAutoFocus: true, formatDate: this.formatDate, isMonthPickerVisible: false, label: strings.fromDateLabel, maxDate: toDate || today, onSelectDate: this.onFromDateChanged, placeholder: strings.datePlaceholder, value: fromDate })),
                        React.createElement("div", { className: styles.dateRefinerContainer },
                            React.createElement(OWADatePicker, { className: styles.datePicker, disableAutoFocus: true, formatDate: this.formatDate, isMonthPickerVisible: false, label: strings.toDateLabel, maxDate: today, minDate: fromDate, onSelectDate: this.onToDateChanged, placeholder: strings.datePlaceholder, value: toDate }))),
                    React.createElement(Link, { className: styles.clearFiltersButton, onClick: this.onClearFiltersClicked }, strings.clearFiltersButtonText)))));
    };
    Object.defineProperty(RefinersCallout.prototype, "folderOptions", {
        /**
         * Getter to get the folder options that are available in the "Folders"
         * dropdown that determines the scope of the search.
         *
         * Entries include:
         * - All folders
         * - Inbox
         * - Deleted Items
         * - Sent Items
         * - Archive (if user has it configured)
         * - The folder search was initiated from (if not one of the above)
         */
        get: function () {
            var currentSearchScope = searchStore.staticSearchScope;
            var searchScopes = searchStore.staticSearchScopeList.slice();
            // Add the current folder scope (if not there already).
            var searchResultArray = searchScopes.filter(function (searchScope) {
                return compareSearchScope(searchScope, currentSearchScope);
            });
            if (searchResultArray.length <= 0) {
                searchScopes.push(currentSearchScope);
            }
            // Add the initial folder scope (if not there already).
            var initialSearchScope = searchStore.initialSearchScope;
            searchResultArray = searchScopes.filter(function (searchScope) {
                return compareSearchScope(searchScope, initialSearchScope);
            });
            if (searchResultArray.length <= 0) {
                searchScopes.push(initialSearchScope);
            }
            // Create the dropdown menu items.
            var items = [];
            for (var _i = 0, searchScopes_1 = searchScopes; _i < searchScopes_1.length; _i++) {
                var searchScope = searchScopes_1[_i];
                items.push({
                    key: getKey(searchScope),
                    text: getSearchScopeDisplayName(searchScope),
                    searchScope: searchScope,
                });
            }
            return items;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Formats date to locale date string.
     * @param date Selected date from the date picker
     */
    RefinersCallout.prototype.formatDate = function (date) {
        return date.toLocaleDateString();
    };
    RefinersCallout = tslib_1.__decorate([
        observer
    ], RefinersCallout);
    return RefinersCallout;
}(React.Component));
export default RefinersCallout;
//# sourceMappingURL=RefinersCallout.js.map